import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import CellItemContainer from '../common/CellItemContainer.jsx';
import * as CellItemImage from '../common/CellItemImage.jsx';
import { Component as CellItemMetaComponent } from '../common/CellItemMeta.jsx';
import { TypeConfig as ItemMetaTypeConfig, } from './ItemCellMeta.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region CONTAINER

const Blocks = {
    get: (group) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: CellItemImage.Component,
            config: {
                Block: CellItemImage.TypeConfig.panel.block(),
                Style: CellItemImage.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: CellItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(),
                Style: ItemMetaTypeConfig.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.ListOrderNumber,
            blockType: Name.Block.Inventory.Meta,
            component: CellItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(ItemMetaTypeConfig.defaultDesignOrder),
                Style: ItemMetaTypeConfig.panel.style()
            },
            display: 'List Order Number',
            group,
            image: ''
        }
    ]
}
const ItemContainer = withBlockRendering(CellItemContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
        case Name.Block.Inventory.Image:
            return { transform: 'c_fit' };
    }
});
const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "5",
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "collapseIfEmpty-col1": true,
                            "width-col1": {
                                "unit": "%",
                                "value": "6"
                            },
                            "alignmentHeader-col2": "ml",
                            "alignment-col2": "tl",
                            "paddingRight-col2": {
                                "unit": "px",
                                "value": "20"
                            },
                            "width-col2": {
                                "unit": "px",
                                "value": "150"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "width-col3": {
                                "unit": "%"
                            },
                            "alignmentHeader-col4": "mr",
                            "alignment-col4": "mr",
                            "collapseIfEmpty-col4": true,
                            "width-col4": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col5": "mr",
                            "alignment-col5": "mr",
                            "collapseIfEmpty-col5": true,
                            "width-col5": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col6": "tl",
                            "alignment-col6": "tl",
                            "width-col6": {
                                "unit": "%"
                            },
                            "renderHeaderOnlyFirst": true
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": ItemMetaTypeConfig.defaultDesignOrder
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-0-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "width": {
                                            "unit": "px",
                                            "value": "150"
                                        }
                                    },
                                    "Style": {
                                        "textAlign": "left"
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": ItemMetaTypeConfig.defaultDesign
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Inventory.Price })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Inventory.DisplayPrice}("before":"","after":"")}`, token: Token.Inventory.DisplayPrice })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-3-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": Name.Content.PricelistInventoryItem
    })
}

// #endregion CONTAINER

export {
    Blocks,
    ItemContainer as Component,
    TypeConfig
}